module.exports = __webpack_public_path__ + "img/notifications--avatar.ae59b2d5.svg";